import { init } from './_jquery';

/** JQuery plugin. */
const jqueryPlugin = {
  init,
};

export default jqueryPlugin;
